import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faChevronCircleRight, } from '@fortawesome/free-solid-svg-icons';
const CurrentQuestion = ({ totalQuestions, question, onOptionSelect, onPrevious, onNext, }) => {
    return (React.createElement("div", { className: "app-container" },
        React.createElement("div", { className: "app-content" },
            React.createElement("div", { className: "question" },
                React.createElement("div", { className: "question-text" }, question.text),
                React.createElement("div", { className: "question-options" },
                    React.createElement("div", { id: "A", className: `question-option ${question.selected === 'A' && 'question-option--selected'}`, onClick: onOptionSelect },
                        "A: ",
                        question.optionA),
                    React.createElement("div", { id: "B", className: `question-option ${question.selected === 'B' && 'question-option--selected'}`, onClick: onOptionSelect },
                        "B: ",
                        question.optionB),
                    React.createElement("div", { id: "C", className: `question-option ${question.selected === 'C' && 'question-option--selected'}`, onClick: onOptionSelect },
                        "C: ",
                        question.optionC),
                    React.createElement("div", { id: "D", className: `question-option ${question.selected === 'D' && 'question-option--selected'}`, onClick: onOptionSelect },
                        "D: ",
                        question.optionD)))),
        React.createElement("div", { className: "app-controls" },
            React.createElement("div", { className: "question-controls" },
                React.createElement("button", { className: "btn--secondary question-controls__action", disabled: question.questionIndex === 0, onClick: onPrevious },
                    React.createElement(FontAwesomeIcon, { icon: faChevronCircleLeft, className: "font-awesome__container" }),
                    "PREVIOUS"),
                React.createElement("button", { className: "btn--secondary question-controls__action", disabled: question.questionIndex === totalQuestions - 1, onClick: onNext },
                    "NEXT",
                    React.createElement(FontAwesomeIcon, { icon: faChevronCircleRight, className: "font-awesome__container" }))))));
};
export { CurrentQuestion };
